module.exports = __webpack_public_path__ + "media/customizations/serranoeldorado/back-a3f538925b774e3ab5e404c67bcbe696.jpg";